module.exports = __webpack_public_path__ + "media/images/welcome1-a60e0e8397e5c9669296e873eb7704b0.jpg";